import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactPane from '../../shared/components/ContactPane';
import {
  ContactsFilter,
  contactsSearched,
  visibilityFilterSet,
} from '../../shared/reducers/contacts';
import { AugmentedPhoneExtension } from '../../shared/services/contactsService';
import { ApiPhonebookEntry } from '../../shared/types/PhonebookEntry';
import { ApiVirtualExtension } from '../../shared/types/VirtualExtension';
import ContactFilterList from '../components/FilterList';
import { startCall, transferCall } from '../reducers/calls';
import { visibleContactsSelector } from '../selectors/contacts';
import { StoreDispatch, StoreState } from '../store';
import * as styles from '../styles/contactList.module.scss';

const filters: { name: string; value: ContactsFilter }[] = [
  {
    name: 'Extensions',
    value: 'SHOW_ENDPOINTS',
  },
  {
    name: 'Phonebook',
    value: 'SHOW_PHONEBOOK',
  },
  {
    name: 'All',
    value: 'SHOW_ALL',
  },
];

const ContactList: React.FC = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const hasGrantedAudio = useSelector(
    (state: StoreState) => state.audio.hasGrantedAudio,
  );
  const visibilityFilter = useSelector(
    (state: StoreState) => state.contacts.visibilityFilter,
  );
  // Contact-click is a blind transfer, so only for an armed inbound leg.
  const transferringCall = useSelector((state: StoreState) =>
    state.calls.find(
      (c) => c.transferInitiated === true && c.direction === 'IN',
    ),
  );
  const isTransferring = !!transferringCall;
  const transferCallId = transferringCall?.id;

  const contacts = useSelector(visibleContactsSelector);

  if (!contacts) {
    return <span>Loading contacts</span>;
  }

  return (
    <>
      <div className={styles.container}>
        <ContactFilterList<ContactsFilter>
          selectedFilter={visibilityFilter}
          filters={filters}
          onSelected={(filter) => {
            dispatch(visibilityFilterSet({ filter }));
          }}
        />
        <ContactPane
          disabled={!hasGrantedAudio}
          showAddButton={visibilityFilter === 'SHOW_PHONEBOOK'}
          contacts={contacts}
          onContactClick={(contact) => {
            const number =
              (contact as AugmentedPhoneExtension | ApiVirtualExtension)
                .shortNumber || (contact as ApiPhonebookEntry).phoneNumber;
            const email = (
              contact as ApiPhonebookEntry | AugmentedPhoneExtension
            ).email;
            if (isTransferring) {
              dispatch(transferCall({ id: transferCallId, number }));
              dispatch(contactsSearched({ searchString: '' }));
            } else {
              dispatch(
                startCall({
                  number,
                  type: contact.type,
                  name: contact.name,
                  description: number,
                  email,
                }),
              );
              dispatch(contactsSearched({ searchString: '' }));
            }
          }}
        />
      </div>
    </>
  );
};

export default ContactList;
